// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3ubZS","footer":"ModalCreateQualiphyProcedure_footer__2zh53","additionData":"ModalCreateQualiphyProcedure_additionData__209Uz"};